import React, { useState } from 'react';
import { 
  db, 
  addDoc, 
  collection, 
  doc, 
  getDoc, 
  setDoc, 
  updateDoc, 
  getDocs, 
  deleteDoc
} from '../firebase';
import { query, where, orderBy } from 'firebase/firestore';

const MessageInput = ({ accountNumber, selectedFriend }) => {
  const [message, setMessage] = useState('');
  const name = localStorage.getItem('name');

  const chatId =
    accountNumber < selectedFriend
      ? `${accountNumber}_${selectedFriend}`
      : `${selectedFriend}_${accountNumber}`;

  const deleteOldestMessage = async () => {
    try {
      const messagesRef = collection(db, 'messages');
      const q = query(
        messagesRef,
        where('chatId', '==', chatId),
        orderBy('timestamp', 'asc')
      );
      const snapshot = await getDocs(q);
      if (snapshot.size >= 5) {
        const oldestMessage = snapshot.docs[0];
        await deleteDoc(doc(db, 'messages', oldestMessage.id));
        console.log('Deleted oldest message.');
      }
    } catch (error) {
      console.error('Error deleting old messages:', error);
    }
  };

  const sendMessage = async () => {
    if (!message.trim() || !selectedFriend) return;
    try {
      await addDoc(collection(db, 'messages'), {
        senderID: accountNumber,
        senderName: name,
        receiverID: selectedFriend,
        text: message,
        timestamp: Date.now(),
        chatId: chatId,
        read: false, // New messages are unread
      });

      const chatRef = doc(db, 'chats', chatId);
      const chatSnap = await getDoc(chatRef);
      if (chatSnap.exists()) {
        await updateDoc(chatRef, {
          lastMessage: message,
          lastTimestamp: Date.now(),
        });
      } else {
        await setDoc(chatRef, {
          participants: [accountNumber, selectedFriend],
          lastMessage: message,
          lastTimestamp: Date.now(),
        });
      }
      
      await deleteOldestMessage();
      
      setMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Type a message..."
        value={message}
        onChange={e => setMessage(e.target.value)}
        maxLength={100}
      />
      <button onClick={sendMessage}>Send</button>
      <p>{message.length}/100 characters</p>
    </div>
  );
};

export default MessageInput;
